module.exports = __webpack_public_path__ + "img/category-title02-MO.4e57d4ff.png";